import { Component, ViewChild, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ApiService } from '../api.service'
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service'; 
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { StripeCardNumberComponent, StripeService } from 'ngx-stripe';
import {StripeCardElementOptions} from '@stripe/stripe-js';
import { Package } from '../models/package.model';
import { DropdownService } from './../dropdown.service';

declare var $: any; 

interface Slide {
  name: string;
  role: string;
  location: string;
  image: string;
}

interface FeaturedMember {
  id: number | null;
  name: string;
  role: string;
  location: string;
  image: string | null;
  verified: boolean;
  has_card?: boolean;
  tier?: string;
  dummy?: boolean;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements AfterViewInit, OnInit, OnDestroy {
  
  isNavOpen = false;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  showLoginPassword: boolean = false; 
  inviteToken: string | null = null; 
  searchAttempted = false;

  showLoginTab: boolean=true;
  showAgeModal: boolean=false;
  showRegisterTab: boolean;
  isMoreTextVisible:boolean = false;
  showStripeModal:boolean = false;
  showPackageModal:boolean = false;
  showPolicyModal:boolean=false
  showRefundModal:boolean=false
  showTermsModal:boolean=false
  showLoadingModal:boolean=false
  packages: any[] = [];
  slides1: any[] = [];
  slides2: any[] = [];
  slideConfig1: any;
  slideConfig2: any;
  slideConfig3: any;
  slideConfig4: any;
  slideConfig5: any;
  slideConfig6: any;
  email: string = ''
  password: string = ''
  form: FormGroup;
  positionType: any = []
  businessType: any = []
  relgionType:any
  sportType: any = []
  ageType: any = []
  selectedSport: any
  form2: FormGroup;
  submitButtonClicked = false;
  form3: FormGroup
  selectedPackage: Package = null;
  cardsSearched:any=[]
  paymentForm:FormGroup
  planID:any
  elements: any; 
  cardElement: any; 
  mode:any
  paypalTitleMessage:any;
  paypalMessage:any;

  medicalType:any
  specialityType:any
location:any
state:any
race:any
gender:any
Strategic_Organizing_Center:any
Largest_Unions:any
Types:any
Independent_National:any
State_and_Local:any
Professional_sports_labor_unions:any
AFL_CIO:any



 slides: Slide[] = [
    {
      name: 'CREATOR ONE',
      role: 'Music Producer',
      location: 'Miami, FL',
      image: 'assets/images/members/member2.png'
    },
    {
      name: 'LADY LUXE',
      role: 'Content Creator',
      location: 'Atlanta, GA',
      image: 'assets/images/members/member1.png'
    },
    {
      name: 'FIT FOCUS',
      role: 'Fitness Trainer',
      location: 'Dallas, TX',
      image: 'assets/images/members/member3.png'
    },
    {
      name: 'BOSS MOVES',
      role: 'Marketing Agency',
      location: 'Houston, TX',
      image: 'assets/images/members/member4.png'
    },
    {
      name: 'GLAM BEAUTY',
      role: 'Beauty Studio',
      location: 'Los Angeles, CA',
      image: 'assets/images/members/member5.png'
    }
  ];

  ngOnDestroy(): void {
    this.stopAutoSlide();

    if ($('.featured-track').hasClass('slick-initialized')) {
      $('.featured-track').slick('unslick');
    }

  }

  autoSlideInterval: any;
currentIndex = 0;

isAnimating = false;

getSlidePosition(index: number): string {

  const total = this.slides.length;

  let diff = index - this.currentIndex;

  // Infinite calculation
  if (diff > total / 2) {
    diff -= total;
  }

  if (diff < -total / 2) {
    diff += total;
  }

  // CENTER
  if (diff === 0) {
    return 'center';
  }

  // LEFT
  if (diff === -1) {
    return 'left';
  }

  // RIGHT
  if (diff === 1) {
    return 'right';
  }

  /*
   * Everything behind the LEFT
   */
  if (diff < -1) {
    return 'behind-left';
  }

  /*
   * Everything behind the RIGHT
   */
  return 'behind-right';
}


nextSlide(): void {

  if (this.isAnimating) {
    return;
  }

  this.isAnimating = true;

  this.currentIndex =
    (this.currentIndex + 1) % this.slides.length;

  setTimeout(() => {
    this.isAnimating = false;
  }, 750);

  this.restartAutoSlide();
}


previousSlide(): void {

  if (this.isAnimating) {
    return;
  }

  this.isAnimating = true;

  this.currentIndex =
    (this.currentIndex - 1 + this.slides.length)
    % this.slides.length;

  setTimeout(() => {
    this.isAnimating = false;
  }, 750);

  this.restartAutoSlide();
}


  // ==========================================
  // AUTO SLIDE
  // ==========================================

  startAutoSlide(): void {

    this.autoSlideInterval = setInterval(() => {

      this.currentIndex =
        (this.currentIndex + 1) % this.slides.length;

    }, 4000);
  }


  // ==========================================
  // RESTART
  // ==========================================

  restartAutoSlide(): void {

    this.stopAutoSlide();

    this.startAutoSlide();
  }


  // ==========================================
  // STOP
  // ==========================================

  stopAutoSlide(): void {

    if (this.autoSlideInterval) {

      clearInterval(this.autoSlideInterval);

      this.autoSlideInterval = null;
    }
  }

  featuredMembers: FeaturedMember[] = [
    { id: 1, name: 'Lady Luxe',    role: 'Content Creator',   location: 'Atlanta, GA',   image: 'assets/images/members/member1.png', verified: true, dummy: true },
    { id: 2, name: 'Yung Reel',    role: 'Music Producer',    location: 'Miami, FL',     image: 'assets/images/members/member2.png', verified: false, dummy: true },
    { id: 3, name: 'Glam Beauty',  role: 'Beauty Studio',     location: 'Los Angeles, CA', image: 'assets/images/members/member3.png', verified: true, dummy: true },
    { id: 4, name: 'Fit Focus',    role: 'Fitness Trainer',   location: 'Dallas, TX',    image: 'assets/images/members/member4.png', verified: false, dummy: true },
    { id: 5, name: 'Boss Moves',   role: 'Marketing Agency',  location: 'Houston, TX',   image: 'assets/images/members/member5.png', verified: false, dummy: true },
    { id: 6, name: 'Style Society',role: 'Fashion Stylist',   location: 'New York, NY',  image: 'assets/images/members/member6.png', verified: true, dummy: true },
    { id: 7, name: 'Sound Wave',   role: 'DJ / Producer',     location: 'Chicago, IL',   image: 'assets/images/members/member7.png', verified: false, dummy: true },
    { id: 8, name: 'Elite Realty', role: 'Real Estate Agent', location: 'Phoenix, AZ',   image: 'assets/images/members/member8.png', verified: false, dummy: true },
  ];

  previousFeatured() {
    $('.featured-track').slick('slickPrev');
  }

  nextFeatured() {
    $('.featured-track').slick('slickNext');
  }


  
  ngOnInit(): void {
    this.startAutoSlide();

    const authTab = this.route.snapshot.queryParamMap.get('authTab');
    if (authTab === 'register') {
      this.showLoginTab = false;   // Register tab open ho jaye
    } else if (authTab === 'login') {
      this.showLoginTab = true;    // Login tab open ho jaye
    }


    this.dropdownService.getDropdownOptions().subscribe(data => {
      this.businessType = data.businessType;
      this.location = data.location;
      this.state = data.state;
      this.gender = data.gender;
      this.race = data.race;
    });




    this.route.queryParams.subscribe(params => {
      const referralId = params['referralId'] || "";
       
      this.form3.get('registerReferralCode')?.setValue(referralId); // Set the referral ID to the form control
    });
   
  
    const videoPath = 'assets/video.mp4';
    this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videoPath);
    this.paymentService.loadingStatus.subscribe((status: boolean) => {
      this.showLoadingModal = status;
    });

    this.apiService.getFeaturedMembers().subscribe(
      (response) => {
        if (response.Cards && response.Cards.length > 0) {
          this.destroyFeaturedSlider();           // pehle slick hatao
          this.featuredMembers = response.Cards;  // phir data badlo
          this.refreshFeaturedSlider();
        }
        // khaali aaye to dummy featuredMembers wese hi rahenge
      },
      (error) => console.error('Error fetching featured members:', error)
    );
    
  }

  refreshFeaturedSlider(): void {
    setTimeout(() => {
      if ($('.featured-track').hasClass('slick-initialized')) {
        $('.featured-track').slick('unslick');
      }
      $('.featured-track').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3500,
        speed: 500,
        arrows: false,
        dots: false,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 3 } },
          { breakpoint: 768,  settings: { slidesToShow: 2 } },
          { breakpoint: 480,  settings: { slidesToShow: 1 } },
        ]
      });
    }, 100);
  }

  destroyFeaturedSlider(): void {
    if ($('.featured-track').hasClass('slick-initialized')) {
      $('.featured-track').slick('unslick');
    }
  }
  
  ngAfterViewInit(): void {
    setTimeout(() => {
      $('.featured-track').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3500,
        speed: 500,
        arrows: false,   // hum apne custom prev/next buttons use kar rahe hain
        dots: false,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 3 } },
          { breakpoint: 768,  settings: { slidesToShow: 2 } },
          { breakpoint: 480,  settings: { slidesToShow: 1 } },
        ]
      });
    });

    $('.moreless-button-he').click(function() {
      $('.moretext-he').slideToggle();
      if ($('.moreless-button-he').text() == "Read more") {
        $(this).text("Read less")
      } else {
        $(this).text("Read more")
      }
    });
        $('.moreless-buttonf').click(function() {
    $('.moretextf').slideToggle();
    if ($('.moreless-buttonf').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
      
        $('.moreless-button15').click(function() {
          event.preventDefault();
    $('.moretext15').slideToggle();
    if ($('.moreless-button15').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button1').click(function() {
          event.preventDefault();
    $('.moretext1').slideToggle();
    if ($('.moreless-button1').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button2').click(function() {
          event.preventDefault();
    $('.moretext2').slideToggle();
    if ($('.moreless-button2').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
      
        $('.moreless-button3').click(function() {
          event.preventDefault();
    $('.moretext3').slideToggle();
    if ($('.moreless-button3').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
      
        $('.moreless-button4').click(function() {
          event.preventDefault();
    $('.moretext4').slideToggle();
    if ($('.moreless-button4').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
     
        $('.moreless-button5').click(function() {
          event.preventDefault();
    $('.moretext5').slideToggle();
    if ($('.moreless-button5').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
   
        $('.moreless-button6').click(function() {
          event.preventDefault();
    $('.moretext6').slideToggle();
    if ($('.moreless-button6').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
    
        $('.moreless-button7').click(function() {
          event.preventDefault();
    $('.moretext7').slideToggle();
    if ($('.moreless-button7').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
    
        $('.moreless-button8').click(function() {
          event.preventDefault();
    $('.moretext8').slideToggle();
    if ($('.moreless-button8').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
     
        $('.moreless-button9').click(function() {
          event.preventDefault();
    $('.moretext9').slideToggle();
    if ($('.moreless-button9').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
      
        $('.moreless-button10').click(function() {
          event.preventDefault();
    $('.moretext10').slideToggle();
    if ($('.moreless-button10').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
     
        $('.moreless-button11').click(function() {
          event.preventDefault();
    $('.moretext11').slideToggle();
    if ($('.moreless-button11').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
      
        $('.moreless-button12').click(function() {
          event.preventDefault();
    $('.moretext12').slideToggle();
    if ($('.moreless-button12').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
      
        $('.moreless-button13').click(function() {
          event.preventDefault();
    $('.moretext13').slideToggle();
    if ($('.moreless-button13').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
     
        $('.moreless-button14').click(function() {
          event.preventDefault();
    $('.moretext14').slideToggle();
    if ($('.moreless-button14').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });






        $('.moreless-button16').click(function() {
          event.preventDefault();
    $('.moretext16').slideToggle();
    if ($('.moreless-button16').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button17').click(function() {
          event.preventDefault();
    $('.moretext17').slideToggle();
    if ($('.moreless-button17').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button18').click(function() {
          event.preventDefault();
    $('.moretext18').slideToggle();
    if ($('.moreless-button18').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button19').click(function() {
          event.preventDefault();
    $('.moretext19').slideToggle();
    if ($('.moreless-button19').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button20').click(function() {
          event.preventDefault();
    $('.moretext20').slideToggle();
    if ($('.moreless-button20').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button21').click(function() {
          event.preventDefault();
    $('.moretext21').slideToggle();
    if ($('.moreless-button21').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button22').click(function() {
          event.preventDefault();
    $('.moretext22').slideToggle();
    if ($('.moreless-button22').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button23').click(function() {
          event.preventDefault();
    $('.moretext23').slideToggle();
    if ($('.moreless-button23').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button24').click(function() {
          event.preventDefault();
    $('.moretext24').slideToggle();
    if ($('.moreless-button24').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button25').click(function() {
          event.preventDefault();
    $('.moretext25').slideToggle();
    if ($('.moreless-button25').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button26').click(function() {
          event.preventDefault();
    $('.moretext26').slideToggle();
    if ($('.moreless-button26').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
        $('.moreless-button27').click(function() {
          event.preventDefault();
    $('.moretext27').slideToggle();
    if ($('.moreless-button27').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
  
  }
  
  
  
  confirmAge() {
    this.showAgeModal = false;
    if (this.mode == 'signup') {
      this.mode = '';

      if (this.inviteToken) {
        // Package/Stripe modal dono skip — seedha register karo
        this.paypalTitleMessage = "Please Wait";
        this.paypalMessage = "Creating your account...";
        this.showLoadingModal = true;
        this.paymentService.registerWithInvite(this.form3, this.inviteToken);
      } else {
        this.openPackageModal();
      }
    }
    if (this.mode == 'login') {
      this.mode = '';
      this.login();
    }
  }
  
  closeAgeModal() {
   this.showAgeModal=false
  }
  
  openAgeModal(value: any) {
    this.mode = value;
    this.showAgeModal = true;
  }
  
  
    
    openPackageModal() {
      this.apiService.checkEmail(this.form3.get('registerEmail')?.value).subscribe(
        (response)=>{
          if(response.status=='Success' || response.message==='Email is already registered.'){
            alert("This Email is already Registered with another account!")
          }
          else{
            this.showPackageModal = true;
          }
        }
      )
    }
    openStripeModal() {
      this.showStripeModal = true;
      this.closePackageModal()
    }
    openTermsModal(){
      this.showTermsModal = true;
    }
    openRefundModal(){
      this.showRefundModal = true;
    }
    openPolicyModal(){
      this.showPolicyModal = true;
    }
    closeStripeModal() {
      this.showStripeModal = false;
    }
    closePackageModal() {
      this.showPackageModal = false;
    }
    closeTermsModal() {
      this.showTermsModal = false;
    }
    closePolicyModal() {
      this.showPolicyModal = false;
    }
    closeRefundModal() {
      this.showRefundModal = false;
    }
    
  
    // check route for mobile view for registration and login tab
    checkRoute(){
    
          this.showLoginTab = !this.showLoginTab;
    }
    
    // toggle read more buttons 
    toggleMoreText(): void {
      this.isMoreTextVisible = !this.isMoreTextVisible;
    }
    isMoreTextVisible2 = false;
    isMoreTextVisible3 = false;
    toggleMoreText2(): void {
      this.isMoreTextVisible2 = !this.isMoreTextVisible2;
    }
    toggleMoreText3(): void {
      this.isMoreTextVisible3 = !this.isMoreTextVisible3;
    }
  
  

    hasSearchFilter(): boolean {
      const f = this.form2.value;
      return [
        f.selectedStateType, f.selectedCity, f.selectedGender,
        f.selectedLocation, f.selectedName, f.selectedRace, f.selectedBusinessType
      ].some(v => v !== null && v !== undefined && String(v).trim() !== '');
    }

    searchCards() {
      if (!this.hasSearchFilter()) {
        return;   // koi filter select nahi, submit nahi hoga
      }

      const payload = {
        state: this.form2.get('selectedStateType').value,
        city: this.form2.get('selectedCity').value,
        gender: this.form2.get('selectedGender').value,
        location: this.form2.get('selectedLocation').value,
        name: this.form2.get('selectedName').value,
        race: this.form2.get('selectedRace').value,
        business_type: this.form2.get('selectedBusinessType').value,
      };

      this.apiService.searchCard(payload).subscribe((response) => {
        this.searchAttempted = true;
        this.cardsSearched = response.Cards || [];
      });
    }

    private tierLabels: { [key: string]: string } = {
      standard: 'Standard',
      verified: 'Verified Member',
      featured: 'Featured',
      business_featured: 'Business Featured',
      member_pro_featured: 'Member Pro Featured',
    };

    showTierBadge(tier: string): boolean {
      return !!tier ;
    }

    tierLabel(tier: string): string {
      return this.tierLabels[tier] ||
        tier.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    }



    getPositionType(sport: any) {
      this.apiService.getPositionType(sport).subscribe(
        (response) => {
          this.positionType = response.types;
        }
      );
    }
    getAgeType() {
      this.apiService.getAgeType().subscribe(
        (response) =>
          this.ageType = response.types
      )
    }
    onSportTypeChange() {
  
      const selectedSport = this.form2.get('selectedSportType')?.value;
      if (selectedSport) {
        
        this.getPositionType(selectedSport);
      }
    }
    onRegisterSportTypeChange() {
  
      const selectedSport = this.form3.get('registerSportType')?.value;
      if (selectedSport) {
        this.getPositionType(selectedSport);
      }
    }
    
    selectPackage(selectedPackage: Package) {
      this.selectedPackage = selectedPackage;
      console.log(this.selectedPackage);
    }
  
  
  
    
    
    submitForm() {
  
      if (!this.form3.valid) {
        this.submitButtonClicked = true;
        
      }
      if (this.form3.valid) {
        this.submitButtonClicked = false;
      }




    }
  
  
  
  
    getBusniessType() {
      this.apiService.getBusinessType().subscribe(
        (response) =>
          this.businessType = response.Categories
      )
    }
    
  
  
  
    login() {
  
      
  
      const emailControl = this.form.get('email');
      const passwordControl = this.form.get('password');
  
      if (emailControl && passwordControl) {
        if (this.form.valid) {
          const email = emailControl.value;
          const password = passwordControl.value;
  
          this.apiService.publicLogin(email, 0, password).subscribe((response) => {
            if(response.status==200){
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('firstname', response.user.firstname);
        localStorage.setItem('lastname', response.user.lastname);
        localStorage.setItem('phone', response.user.phone);
        localStorage.setItem('email', response.user.email);
        localStorage.setItem('user_id', response.user.id.toString());
        localStorage.setItem('pg_id', "0");
                    this.router.navigate(['/cards']);
            }
            
            else if(response.error=='Unauthorized'){
              alert("login Failed: Unauthorized")
            }
            else{
              alert("login Failed: Unauthorized")
            }
          },(error)=>{
            alert("login Failed: Unauthorized")
          });
        } else {
          alert("invalid login form")
        }
      }
    }
  
    
  
   // VALIDATORS FOR FORMS  
  
    emailMatchValidator = (control: AbstractControl): { [key: string]: boolean } | null => {
      const email = control.get('registerEmail');
      const confirmEmail = control.get('registerConfirmEmail');
  
      // Return an error if the emails don't match
      if (email?.value !== confirmEmail?.value) {
        return { emailMismatch: true };
      }
  
      return null;
    };

    passwordMatchValidator = (control: AbstractControl): { [key: string]: boolean } | null => {
      const password = control.get('registerPassword');
      const confirmPassword = control.get('registerConfirmPassword');

      if (password?.value !== confirmPassword?.value) {
        return { passwordMismatch: true };
      }

      return null;
    };
  
    expiryDateValidator(control: AbstractControl): ValidationErrors | null {
      const expiryDatePattern = /^(0[1-9]|1[0-2])\/\d{2}$/; // MM/YY format
      if (control.value && !expiryDatePattern.test(control.value)) {
        return { invalidExpiryDate: true };
      }
    
      const [month, year] = control.value.split('/');
      const currentYear = new Date().getFullYear() % 100;
      const currentMonth = new Date().getMonth() + 1;
    
      if (Number(year) < currentYear || (Number(year) === currentYear && Number(month) < currentMonth)) {
        return { expiredExpiryDate: true };
      }
    
      return null;
    }
    
    cardNumberValidator(control: AbstractControl): ValidationErrors | null {
      const cardNumberPattern = /^\d{16}$/; // Assuming 16 digits for a valid card number
      if (control.value && !cardNumberPattern.test(control.value)) {
        return { invalidCardNumber: true };
      }
      return null;
    }
    videoUrl: SafeResourceUrl;


    clearSession() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('firstname');
      localStorage.removeItem('lastname');
      localStorage.removeItem('phone');
      localStorage.removeItem('email');
      localStorage.removeItem('user_id');
      localStorage.removeItem('pg_id');
    }
  
    constructor(private apiService: ApiService, private fb: FormBuilder,  private http: HttpClient,private route: ActivatedRoute, private dropdownService: DropdownService,
      private router: Router, private paymentService: PaymentService,private sanitizer: DomSanitizer,private stripeService: StripeService) {
  
        const token = new URLSearchParams(window.location.search).get('token');
        this.inviteToken = new URLSearchParams(window.location.search).get('invite_token');
        
         
        const updatedPlanId=localStorage.getItem("updatePaypalId")
        
        if(updatedPlanId!=null && updatedPlanId){
          localStorage.setItem("updatedToken",token)
        }
        //check if user already available (redirect to cards)
        const email = localStorage.getItem('email');
        const access_token = localStorage.getItem('access_token');
        const user_id = localStorage.getItem('user_id');

        if (email && access_token && user_id) {
          // Token exist karta hai, lekin pehle verify karo ke wo abhi bhi valid hai
          this.apiService.verifyToken(access_token).subscribe(
            (response) => {
              if (response.status === 200 || response.id) {
                this.router.navigate(['/cards']);
              } else {
                this.clearSession();
              }
            },
            (error) => {
              // Token expired/invalid — session clear karo, login page pe hi raho
              this.clearSession();
            }
          );
        }     
  
  
    
        
        if(token && (updatedPlanId=='' || updatedPlanId==null)){
          this.paypalTitleMessage="Please Wait"
          this.paypalMessage="Your Paypal payment is being processed. Your patience is appreciated."

   
          this.showLoadingModal=true
          
          this.apiService.executeAggrement(token)
          .subscribe(
            (response) => {
              // Subscription is now active
              if(response.status=='Success'){
                this.paypalTitleMessage="Payment Successful!"
                
                this.paypalMessage="Thank you for successfully completing your payment through PayPal. Your transaction has been processed, and it may take a few minutes for us to update your payment status on our end. We appreciate your patience. If you have any questions or concerns, please don't hesitate to contact us for assistance."
                console.log("Billing agreement executed successfully", response);
                this.paymentService.paypal_Register_user(response.subscription_id)
              }
              
              
            },
            (error) => {
              console.error("Failed to execute billing agreement", error);
              this.showLoadingModal=false
                alert("We're sorry, it seems that your payment through PayPal was not completed successfully. if you continue to experience difficulties, please contact us!")
                window.location.href='https://umyogossip.site/'
            }
          );
        }
  
        
  
  
  
      // form is login form 
      // form2 is search of cards form 
      // from 3 is registration form 
    const cvcLength = 3;
    this.paymentForm = this.fb.group({
    cardNumber: ['', [Validators.required, this.cardNumberValidator]],
    expiryDate: ['', [Validators.required, this.expiryDateValidator]],
    cvc: ['', [Validators.required, Validators.minLength(cvcLength), Validators.maxLength(cvcLength)]],
  });
      this.form = this.fb.group({
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required]],
      });
  
      this.form2 = this.fb.group({
        
    
        
        selectedStateType: [''],
        selectedName: [''],
        selectedRace: [''],
        selectedCity: [''],
        selectedBusinessType: [''],
        selectedLocation:[''],
        selectedGender:['']
     
        
        

      });
      this.form3 = this.fb.group({
          registerFirstName: ['', Validators.required],
        registerLastName: ['', Validators.required],
        registerEmail: ['', [Validators.required, Validators.email]],
        registerConfirmEmail: ['', [Validators.required, Validators.email]],
        registerPassword: ['', [Validators.required, Validators.minLength(6)]],
        registerConfirmPassword: ['', [Validators.required, Validators.minLength(6)]],
        registerPhone: ['', Validators.required],
        registerCityType: ['', Validators.required],
        registerRaceType: ['', Validators.required],
        registerLocation: ['', Validators.required],
        registerGenderType: ['', Validators.required],
        registerBusiness: ['', Validators.required],
        registerStateType: ['', Validators.required],
        registerReferralCode: [''],
      }, { validators: [this.emailMatchValidator, this.passwordMatchValidator] })


      // fetch packages
      this.apiService.getSignUpPackages(null).subscribe(
        (response) => {
          this.packages = response.Package
          console.log(response.Package);
        },
        (error) => {
          console.error('Error fetching users:', error);
        }
      );
  
      this.slideConfig1 = {
        dots: false,
        arrows:false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1,
        speed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: false,
        rtl: false,
        cssEase: 'linear'
      };
  
  
      this.slideConfig2 = {
        arrows:false,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1,
        speed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow:1,
        slidesToScroll: 1,
        fade: false,
        rtl: true,
        cssEase: 'linear'
      };
      this.slideConfig3 = {
        dots: false,
        arrows:false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1,
        speed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        fade: false,
        rtl: false,
        cssEase: 'linear'
      };
  
  
      this.slideConfig4 = {
        arrows:false,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1,
        speed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow:4,
        slidesToScroll: 1,
        fade: false,
        rtl: true,
        cssEase: 'linear'
      };
      this.slideConfig5 = {
        dots: false,
        arrows:false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1,
        speed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        fade: false,
        rtl: false,
        cssEase: 'linear'
      };
  
  
      this.slideConfig6 = {
        arrows:false,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1,
        speed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow:2,
        slidesToScroll: 1,
        fade: false,
        rtl: true,
        cssEase: 'linear'
      };
  
  
      this.slides1 = [
        { img: 'assets/img/logo2/blackwall.png' },
        { img: 'assets/img/logo2/events.png' },
        { img: 'assets/img/logo2/logo2.png' },
        { img: 'assets/img/logo2/logo3.png' },
        { img: 'assets/img/logo2/logo4.png' },
        { img: 'assets/img/logo2/logo5.png' },
        { img: 'assets/img/logo2/logo6.png' },
        { img: 'assets/img/logo2/logo7.png' },
        { img: 'assets/img/logo2/logo8.png' },
        { img: 'assets/img/logo2/logo9.png' },
        { img: 'assets/img/logo2/logo10.png' },
  
      ];
  
  
      this.slides2 = [
        { img: 'assets/img/logo2/logo11.png' },
        { img: 'assets/img/logo2/logo12.png' },
        { img: 'assets/img/logo2/logo13.png' },
        { img: 'assets/img/logo2/logo14.png' },
        { img: 'assets/img/logo2/logo15.png' },
        { img: 'assets/img/logo2/logo16.png' },
        { img: 'assets/img/logo2/pledge.png' },
        { img: 'assets/img/logo2/logo9.png' },
        { img: 'assets/img/logo2/umyo_market.png' },
        { img: 'assets/img/logo2/logo8.png' },
        { img: 'assets/img/logo2/umyodate.png' },
  
      ];
  
    }
    getSportType() {
      this.apiService.getSportType().subscribe(
        (response) =>
          this.sportType = response.types
      )
    }
  
    
    
  
  
  
  // STRIPE PAYMENT 
  @ViewChild(StripeCardNumberComponent) card: StripeCardNumberComponent;
  
  public cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        fontWeight: 400,
        fontFamily: 'Poppins, Segoe UI, sans-serif',
        fontSize: '15px',
        iconColor: '#E4002B',
        color: '#f5f5f7',
        '::placeholder': {
          color: '#8a8594',
        },
      },
      invalid: {
        color: '#ff4f61',
        iconColor: '#ff4f61',
      },
    },
  };
  
  pay(): void {
    if (!this.selectedPackage) {
      alert('Please select a package.');
      return;
    }

    this.stripeService.createToken(this.card.element).subscribe(result => {
      if (result.token) {
        this.closePackageModal();
        this.closeStripeModal();
        this.paypalTitleMessage = "Please Wait";
        this.paypalMessage = "Your Stripe payment is being processed. Your patience is appreciated.";
        this.showLoadingModal = true;
        this.paymentService.createPaymentIntent(
          result.token.id,
          this.form3,
          this.selectedPackage
        );
      } else if (result.error) {
        alert(result.error.message); // Stripe khud error message deta hai
      }
    });
  }
  
  
  //PAYPAL PAYMENT 
  
  paypalClick(){
   this.closePackageModal()
   this.paypalTitleMessage="Redirecting to PayPal"
   this.paypalMessage="You are now being redirected to the PayPal website to complete your transaction securely. Please wait a moment while we process your request. If you encounter any issues or have any questions, feel free to contact us for assistance."
   this.showLoadingModal=true
   this.paymentService.paypal_create_billing_plan(this.form3,this.selectedPackage)
  }
  
  
  // CONTINUE PAYMENT FOR TESTING  OF 0$
  
  continuePaymentButton(){
    this.paymentService.testing(this.form3,this.selectedPackage);
  }
  
  
  
  }